import PropTypes from 'prop-types'

export default PropTypes.shape({
   fullName: PropTypes.string,
   isLoggedIn: PropTypes.bool.isRequired
})
